import _extends from "@babel/runtime/helpers/extends";
import Container from "../common/Container.js";
import Version from "./Version.js";
import Size from "./Size.js";
import Downloads from "./Downloads.js";
import { jsx as _jsx } from "react/jsx-runtime";
var Npm = props => /*#__PURE__*/_jsx(Container, _extends({}, props));
Npm.Version = Version;
Npm.Size = Size;
Npm.Downloads = Downloads;
Npm.displayName = 'Npm';
export default Npm;